import { dashboardApiBaseUrl, tokenAuthErrors } from './auth-mode'
import type { DashboardUser } from './context'

const TOKEN_PREFIX = 'usars_'

export class TokenAuthError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'TokenAuthError'
  }
}

export function validateStagingApiToken(token: string): string {
  const trimmed = token.trim()
  if (!trimmed) {
    throw new TokenAuthError('Enter a USA-RS API token.')
  }
  if (!trimmed.startsWith(TOKEN_PREFIX)) {
    throw new TokenAuthError('Token must start with usars_.')
  }
  return trimmed
}

function userFromResponse(data: unknown): DashboardUser {
  const candidate = data as Partial<{
    id: string | number
    user_id: string
    email: string
    name: string | null
  }>
  const email = candidate.email || candidate.user_id || 'staging-token-user@shopusars.com'
  return {
    id: String(candidate.user_id || candidate.id || email),
    email,
    name: candidate.name ?? null,
  }
}

export async function verifyStagingToken(token: string, fetchImpl: typeof fetch = fetch): Promise<DashboardUser> {
  const response = await fetchImpl(`${dashboardApiBaseUrl}/dashboard/staff/me`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })

  if (response.status === 401 || response.status === 403) {
    throw new TokenAuthError(tokenAuthErrors.rejected)
  }
  if (!response.ok) {
    throw new TokenAuthError(tokenAuthErrors.unavailable)
  }

  return userFromResponse(await response.json())
}
